import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function FullCarDetailPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Full Car Detail',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Ventura County', 'Camarillo', 'Oxnard', 'Ventura', 'Thousand Oaks'],
    description: 'Complete mobile full car detailing service combining deep interior cleaning and premium exterior wash, clay bar, and wax protection.'
  };
  const faqs = [{
    question: 'What is included in a full car detail?',
    answer: 'A full detail combines our complete interior and exterior services: deep vacuuming, shampooing, steam sanitizing, leather conditioning, a safe hand wash, clay bar decontamination, wheel and tire detailing, and premium paint protection.'
  }, {
    question: 'How long does a full detail take?',
    answer: 'A full detail typically takes 3\u20134 hours depending on the size and condition of your vehicle. We never rush \u2014 quality results take proper time and attention.'
  }, {
    question: 'How much does a full car detail cost?',
    answer: 'Our full detail starts at $300, with pricing adjusted for vehicle size and condition. SUVs and trucks are slightly higher. Call (818) 381-9905 for an exact quote.'
  }, {
    question: 'Is a full detail worth it before selling my car?',
    answer: 'Absolutely. A full detail is one of the most cost-effective ways to maximize resale value, presenting your vehicle in its best possible condition inside and out.'
  }, {
    question: 'Do you come to my home or office for a full detail?',
    answer: 'Yes. We are fully mobile, bringing our own water and detailing equipment to your home or office anywhere in Ventura County. We require access to a standard electrical outlet at the service location.'
  }];
  const breadcrumbs = [{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/#services'
  }, {
    name: 'Full Car Detail',
    item: 'https://www.fulldetailpro.com/services/full-car-detail'
  }];
  return <ServicePageLayout title="Full Car Detail Ventura County" subtitle="Our most popular package. A complete bumper-to-bumper transformation combining our premium interior and exterior detailing services." metaDescription="Complete full car detail in Ventura County \u2014 Camarillo, Oxnard & Thousand Oaks. Mobile interior deep clean + exterior wax & wax. Call (818) 381-9905." schema={schema} faqs={faqs} breadcrumbs={breadcrumbs} data-id="element-875" data-mp="2imgnu71oj4xi">
      <p data-id="element-876" data-mp="1zomaxhxfk99u">
        If you want your vehicle to look and feel as close to brand new as
        possible, our <strong data-id="element-877" data-mp="3q1lg01hu1cfc">Full Car Detail</strong> is the ultimate solution.
        This comprehensive package combines the deep-cleaning power of our
        interior detailing with the protective, gloss-enhancing benefits of our
        exterior detailing. At Mike's Pro Detail, we provide top-tier mobile
        auto detailing in Camarillo CA, Thousand Oaks, and throughout Ventura
        County, bringing a complete automotive makeover directly to your
        driveway or workplace.
      </p>

      <h2 data-id="element-878" data-mp="1nck4zo3m08js">What's Included in a Full Detail?</h2>
      <p data-id="element-879" data-mp="1nbs8mb26u6sg">
        The Full Detail package leaves no stone unturned. We spend hours
        meticulously cleaning, restoring, and protecting every surface of your
        vehicle.
      </p>

      <h3 data-id="element-880" data-mp="1x5iv5aer875i">Exterior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-881" data-mp="2b3pme7p778w7">
        <li className="flex items-start" data-id="element-882" data-mp="2b2ehu5nxhx41">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-883" data-mp="264cqyyk9gti0" />
          <span data-id="element-884" data-mp="262a06cbaawc8">Wash method to safely remove surface dirt and grime.</span>
        </li>
        <li className="flex items-start" data-id="element-885" data-mp="gpeufqdb3ym7">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-886" data-mp="bqlhq05ugbn3" />
          <span data-id="element-887" data-mp="bsg5rncewjve">
            <strong data-id="element-888" data-mp="e50eru4b38w1">Decontamination & Clay Bar:</strong> Removal of embedded
            iron particles, tree sap, and road tar to leave the paint smooth.
          </span>
        </li>
        <li className="flex items-start" data-id="element-889" data-mp="i86kn0niay1z">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-890" data-mp="n6gftb98dynl" />
          <span data-id="element-891" data-mp="s49l822pmomt">
            <strong data-id="element-892" data-mp="s4rohinsi348">Wheel & Tire Detail:</strong> Deep cleaning of wheel
            barrels, faces, and tires, finished with a premium no-sling
            dressing.
          </span>
        </li>
        <li className="flex items-start" data-id="element-893" data-mp="3vkp1s0h8zr6s">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-894" data-mp="3vlhzyd2558db" />
          <span data-id="element-895" data-mp="4dw1cyua3w3b">
            <strong data-id="element-896" data-mp="4dcjfi4mp7pa">Paint Protection:</strong> Application of a high-grade
            hybrid ceramic wax or sealant for months of gloss and UV protection.
          </span>
        </li>
      </ul>

      <h3 data-id="element-897" data-mp="37uuq3m8o08o4">Interior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-898" data-mp="37ttdhdc03e4a">
        <li className="flex items-start" data-id="element-899" data-mp="3ctp8in2pzv7p">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-900" data-mp="3cse2shppsddy" />
          <span className="font-[400]" data-id="element-901" data-mp="35apoqgbck1nt">
            Deep Vacuuming: Thorough removal of dirt and pet hair, followed
            steam clean carpets and cloth seats.
          </span>
        </li>
        <li className="flex items-start" data-id="element-902" data-mp="2vbqn3hp016ab">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-903" data-mp="2qdyyoxnkc2av" />
          <span data-id="element-904" data-mp="2qdp755mvdn32">
            <strong data-id="element-905" data-mp="2qgbcqzq79sin">Leather Treatment:</strong> Gentle cleaning and premium
            conditioning to restore softness and prevent cracking.
          </span>
        </li>
        <li className="flex items-start" data-id="element-906" data-mp="2hk2f9qls93z5">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-907" data-mp="2cmk4duo7geoi" />
          <span data-id="element-908" data-mp="2cmtxhr4jr1yf">
            <strong data-id="element-909" data-mp="2ck7qbslkiogq">Surface Sanitization:</strong> Steam cleaning of vents, cup
            holders, and dashboard to kill bacteria and remove sticky residues.
          </span>
        </li>
        <li className="flex items-start" data-id="element-910" data-mp="22qgzih1yy1xv">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-911" data-mp="1ymj1yasakz6x" />
          <span data-id="element-912" data-mp="1o1nphefbbri8">
            <strong data-id="element-913" data-mp="1o15xwv3li1gn">Crystal Clear Glass:</strong> Streak-free cleaning of all
            interior and exterior windows and mirrors.
          </span>
        </li>
      </ul>

      <h2 data-id="element-914" data-mp="1sye6c3yxyr4p">The Ultimate Value and Convenience</h2>
      <p data-id="element-915" data-mp="1f210xt7omg6l">
        Booking a Full Car Detail is the most cost-effective way to completely
        reset your vehicle's condition. Whether you are preparing to sell your
        car, returning a lease, or simply want to fall in love with your daily
        driver all over again, this package delivers unmatched results. Plus,
        because we are a fully mobile operation, you don't have to waste your
        day sitting in a waiting room. We bring our own water and detailing
        equipment, and we require access to a standard electrical outlet at the
        service location, allowing you to continue working or relaxing at home
        while we transform your car.
      </p>

      <h2 data-id="element-916" data-mp="2vfhdv920sr8y">Your Local Mobile Detailing Experts</h2>
      <p data-id="element-917" data-mp="2vhbzyqp12pem">
        When residents search for "Car Detailing Camarillo" or "Mobile Detailing
        Ventura County", they consistently choose Mike's Pro Detail for our
        reliability, attention to detail, and exceptional customer service. From
        Camarillo to Moorpark, we are dedicated to providing the highest
        standard of mobile auto detailing available in Southern California.
      </p>

      <h2 data-id="element-918" data-mp="39n3voxvkxddf">Related Detailing Services</h2>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-919" data-mp="2luf0cubt4e2e">
        <Link to="/services/interior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-920" data-mp="2htv2tpnbn8fq">
          Interior Detailing &rarr;
        </Link>
        <Link to="/services/exterior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-921" data-mp="2qsyn2wy85tvt">
          Exterior Detailing &rarr;
        </Link>
        <Link to="/services/engine-bay-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-922" data-mp="20ksrzo8e0b05">
          Engine Bay Detailing &rarr;
        </Link>
        <Link to="/services/hybrid-ceramic-spray" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-923" data-mp="29j4ilq9978sl">
          Hybrid Ceramic Spray &rarr;
        </Link>
      </div>
    </ServicePageLayout>;
}